import classNames from "classnames/bind";
import styles from './Config.module.css';
import { Empty, Switch } from "../../../../components";
import TabBar from "../TabBar";
// import { tabs } from "./configTabBar";
import { useContext, useEffect, useState } from "react";
// import { LisencePlateManagerContext } from "../../../../contexts";
import ConfigVariable from "./ConfigVariable";
import ConfigZone from "./ConfigZone";
import { aiConfigFRS } from "../../../../services/api/aiConfigFRS";
import { aiConfigService } from "../../../../services/api/aiConfigService";
import { configDefault } from "../../../../services/api/configDefault";
import { SCECHULE } from "../../../../utils";
import ConfigLockObject from "./ConfigLockObject";
import axiosClient from "../../../../services/axiosClient";
import { useTranslation } from "react-i18next";
import { ConfigVariableCamUniview, ConfigZoneUniview } from "./ConfigCamUniview";
import { cameraManagement } from "../../../../services/api/cameraManagementApi";
import { configFrsUniview } from "../../../../services/api/configFrsUniview";

const cx = classNames.bind(styles);

function ConfigFRS({ cameraCode, ...props }) {
    // const { cameraCode } = useContext(LisencePlateManagerContext)
    const { onClose, showAction } = props;
    const [tabActive, setTabActive] = useState(0);
    const [statusAi, setStatusAi] = useState(false);
    const [companyOfCam, setCompanyOfCam] = useState({
        camera_code: null,
        camera_name: null,
    });
    const [isChanged, setIsChanged] = useState(false);
    const [typeCamera, setTypeCamera] = useState("");
    const handleChangeTab = (tabIndex) => {
        setTabActive(tabIndex)
    }
    const { t } = useTranslation()

    const getCheckAiConfig = async () => {
        try {
            const param = {
                camera_code: cameraCode,
                ai_service_code: "20230222000000000002",
            }
            const res = await aiConfigFRS.getListCheckConfigAI(param)
            if (res && res?.length > 0) {
                setStatusAi(res[0]?.STATUS === "1")
            }
        } catch (error) {
            // console.log(error);
        }
    }

    // Lấy thông tin dạng camera
    const getTypeCamera = async () => {
        try {
            const param = {
                camera_code: cameraCode
            }
            const res = await cameraManagement.getOne(param);
            setTypeCamera(res[0]?.CAMERA_TYPE_CODE);
        } catch (error) {
        }
    }

    console.log('type',typeCamera);
    

    useEffect(() => {
        getCheckAiConfig()
        getTypeCamera()
    }, [cameraCode])

    useEffect(() => {
        // Lấy thông tin công ty để thực hiện khi lưu cài đặt
        const getCameraInfo = async () => {
            try {
                const res = await axiosClient.get(
                    `cameraManagement/get-camera-info-by-code/?camera_code=${cameraCode}`
                );
                setCompanyOfCam({
                    company_code: res[0]?.COMPANY_CODE,
                    company_name: res[0]?.COMPANY_NAME
                })
            } catch (e) {
                // console.log(e);
            }
        };
        getCameraInfo()
    }, [cameraCode])

    const tabs = [
        {
            tabIndex: 0,
            tabName: t("faceDetect.variable"),
            component: typeCamera === "UNI_FRS" ? <ConfigVariableCamUniview
                cameraCode={cameraCode}
                onClose={onClose}
                statusAi={statusAi}
                companyOfCam={companyOfCam}
                isChanged={isChanged}
                setIsChanged={setIsChanged}
            /> : <ConfigVariable
                cameraCode={cameraCode}
                onClose={onClose}
                statusAi={statusAi}
                companyOfCam={companyOfCam}
                isChanged={isChanged}
                setIsChanged={setIsChanged}
            />
        },
        {
            tabIndex: 1,
            tabName: t("faceDetect.roiList"),
            component: typeCamera === "UNI_FRS" ? <ConfigZoneUniview
                cameraCode={cameraCode}
                onClose={onClose}
                statusAi={statusAi}
                companyOfCam={companyOfCam}
            /> : <ConfigZone
                cameraCode={cameraCode}
                onClose={onClose}
                statusAi={statusAi}
                companyOfCam={companyOfCam}
            />
        },
        {
            tabIndex: 2,
            tabName: t("faceDetect.fileLock"),
            component: <ConfigLockObject
                cameraCode={cameraCode}
                onClose={onClose}
                statusAi={statusAi}
                companyOfCam={companyOfCam}
                showAction={showAction}
            />
        },

    ]
    return (
        <div className={cx('config-wrapper')}>
            {cameraCode ? (
                <div className={cx('main-config')}>
                    <div className={cx('content-config')}>
                        <div className={cx("item-setting")}>
                            <span className={cx("name")}>{t("stream.status")}</span>
                            <span
                                style={{ position: "relative", right: 0, marginTop: 0 }}
                                className={cx("info")}
                            >
                                <Switch
                                    value={statusAi}
                                    type="small"
                                    onChange={(val) => {
                                        setStatusAi(val);
                                        setIsChanged(true);
                                    }}
                                    disable={false}
                                />
                            </span>
                        </div>
                        <TabBar
                            listTabBar={tabs}
                            getTabActive={handleChangeTab}
                            tabActive={tabActive}
                        />
                        {tabs.length > 0 && tabs.map((item) => {
                            if (item.tabIndex === tabActive) {
                                return (
                                    <div key={item.tabIndex}>{item.component}</div>
                                )
                            } else {
                                return (
                                    <div key={item.tabIndex}></div>
                                )
                            }
                        })}
                    </div>
                </div>
            ) : <div className={cx('no-camera')}>{t("faceDetect.choseCameraConfig")}!</div>}
        </div>
    )
}

export default ConfigFRS;